import { createRef, Component, Fragment } from "react"
import PropTypes from "prop-types"
import tippy from "tippy.js"

// Via: https://gist.github.com/atomiks/25ba93a551fc1e8a1ef18aa7669c6699
class Tippy extends Component {
  html = createRef()
  wrapper = createRef()

  componentDidMount() {
    const { children, ...props } = this.props

    this.tippyInstance = tippy.one(this.wrapper.current, {
      ...props,
      html: this.html.current,
    })
  }

  componentDidUpdate() {
    if (!this.props.html) {
      this.tippyInstance.popper.querySelector(".tippy-content")[
        this.props.allowTitleHTML ? "innerHTML" : "textContent"
      ] = this.props.children.props.title
    }

    if (this.tippyInstance) {
      this.tippyInstance.destroy()
      this.tippyInstance = null
    }

    const { children, ...props } = this.props
    this.tippyInstance = tippy.one(this.wrapper.current, {
      ...props,
      html: this.html.current,
    })
  }

  componentWillUnmount() {
    if (this.tippyInstance) {
      this.tippyInstance.destroy()
      this.tippyInstance = null
    }
  }

  render() {
    return (
      <div ref={this.wrapper}>
        <Fragment>
          {this.props.children}
          {this.props.html && <div ref={this.html}>{this.props.html}</div>}
        </Fragment>
      </div>
    )
  }
}

Tippy.propTypes = {
  html: PropTypes.node,
  allowTitleHTML: PropTypes.bool,
  children: PropTypes.object,
}

export default Tippy
